export const BASE_URL: string = process.env.REACT_APP_API_KEY || "";
// const BASE_URL: string = "http://178.128.61.122:8084";
// const IMAGE_URL: string = 'http://178.128.61.122:8084';

export const MERCHANT_STORE_FIND_MANY: string = BASE_URL + '/merchant/merchant-store/find-many';
export const MERCHANT_STORE_CREATE: string = BASE_URL + '/merchant/merchant-store/create-merchant';
export const MERCHANT_STORE_UPDATE: string = BASE_URL + '/merchant/merchant-store/update?id=';
export const MERCHANT_STORE_UPDATE_LOCATION: string = BASE_URL + '/merchant/merchant-store/update-location-merchant?id=';
export const MERCHANT_STORE_DELETE: string = BASE_URL + '/merchant/merchant-store/delete?id=';

export const IMAGE_MERCHANT_URL : string = BASE_URL + '/merchant/api/';

